import { useState } from "react";
import AccountLayout from "../layouts/AccountLayout";
import './../styles/change-password.css';
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import { ClipLoader } from "react-spinners";
import ToastNotification, { showTopCenterToast } from "../components/toasts/ToastNotification";
import { changePassword } from "../api/user.api";

export const ChangePassword = () => {
  const [isDisplay, setIsDisplay] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !confirmNewPassword) {
      showTopCenterToast("Vui lòng nhập đầy đủ thông tin", "error");
      return;
    }

    if (confirmNewPassword !== newPassword) {
      showTopCenterToast("Xác nhận mật khẩu không đúng", "error");
      return;
    }

    try {
      setLoading(true);

      const res = await changePassword(currentPassword, newPassword, confirmNewPassword);

      if (res.success) {
        showTopCenterToast("Đổi mật khẩu thành công", "success");

        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      }
    } catch (error) {
      showTopCenterToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AccountLayout title={"Thay đổi mật khẩu"}>
      <section className="cpw-shell">
        <header className="cpw-head">
          <h1 className="cpw-title">Cập nhật mật khẩu</h1>
          <p className="cpw-subtitle">Sử dụng mật khẩu mạnh và khác với mật khẩu cũ để tăng bảo mật.</p>
        </header>

        <div className="cpw-form">
          <label className="cpw-field">
            <span className="cpw-label">Mật khẩu hiện tại</span>
            <div className="cpw-input-wrap">
              <input
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                type={isDisplay ? "text" : "password"}
                className="cpw-input"
              />
              {!isDisplay ? (
                <IoEye onClick={() => setIsDisplay(!isDisplay)} className="cpw-eye-icon" />
              ) : (
                <IoEyeOff onClick={() => setIsDisplay(!isDisplay)} className="cpw-eye-icon" />
              )}
            </div>
          </label>

          <label className="cpw-field">
            <span className="cpw-label">Mật khẩu mới</span>
            <div className="cpw-input-wrap">
              <input
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                type={isDisplay ? "text" : "password"}
                className="cpw-input"
              />
            </div>
          </label>

          <label className="cpw-field">
            <span className="cpw-label">Xác nhận mật khẩu mới</span>
            <div className="cpw-input-wrap">
              <input
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                type={isDisplay ? "text" : "password"}
                className="cpw-input"
              />
            </div>
          </label>

          <button onClick={handleChangePassword} className={`cpw-submit-btn ${loading ? "disabled-button" : ""}`} type="button">
            {loading ? <ClipLoader color="#fff" size={20} /> : "Đổi mật khẩu"}
          </button>
        </div>
      </section>

      <ToastNotification />
    </AccountLayout>
  );
};
